import {
  ToastData,
  ToastPayload,
  DELETE_TOAST,
  PUSH_TOAST,
  POP_TOAST,
  FLUSH_TOAST
} from "./types";

const initialState: ToastData = {
  toastList: []
};
enum ItemType {
  success = "success",
  error = "error",
}
export function Toast(
  state = initialState,
  action: ToastPayload
): ToastData {
  switch (action.type) {

    case FLUSH_TOAST:
      return { ...state, toastList: [] };

    case DELETE_TOAST:
      const removedList: any[] = state.toastList.filter((item) => {
        return item.id !== action.data
      })
      return { ...state, toastList: removedList };

    case POP_TOAST:
      const poppedList: any[] = [...state.toastList]
      poppedList.forEach((item: { type: ItemType }, index: number) => {
        if (item.type === "success" || item.type === "error") {
          poppedList.splice(index, 1);
          return;
        }
      });
      return { ...state, toastList: poppedList }

    case PUSH_TOAST:
      return { ...state, toastList: [...state.toastList, action.data] };

    default:
      return state;
  }
}
